/* eslint-disable */
import moment from 'moment';

/*
 * Se eliminan los roles principales, puesto que no se puede editar la titularidad de las cuentas
 * y si se pusiera alguno de esos roles, implicaría dicho cambio
 * ["TITULAR", "NUDO_PROPIETARIO"];
 */
const roles = {
    ADMINISTRADOR: 'ADMINISTRADOR',
    APODERADO: 'APODERADO',
    AUTORIZADO: 'AUTORIZADO',
    AUTORIZADO_CONSULTA: 'AUTORIZADO_CONSULTA',
    REPRESENTANTE_LEGAL: 'REPRESENTANTE_LEGAL',
    USUFRUCTUARIO: 'USUFRUCTUARIO',
    JUNTA_DIRECTIVA: 'CONSEJO DE ADMINISTRACIÓN',
    TUTOR: 'TUTOR'
};


const notExist = (others, ROLE) =>
    others.findIndex(
        x => x.account_intervener_role &&
        x.account_intervener_role.includes(ROLE)) < 0;

const onlyOne = (others, ROLE) =>
    others.filter(
        x => x.account_intervener_role &&
        x.account_intervener_role.includes(ROLE)).length === 1;

const notBe = (me, ROLE) =>
    !me.account_intervener_role ||
    !me.account_intervener_role.includes(ROLE);

/**
 * Retorna roles en el caso de cuentas de tipo persona jurídica
 * @param {*} others otros intervinientes de la cuenta
 * @param {*} me interviniente actual
 * @return {*} roles
 */
export function canLPRoles(others, me) {
    const roleOptions = [];

    // ADMINISTRADOR
    if (
        !me.is_minor &&
        me.intervener_type === 'F' &&
        notBe(me, roles.APODERADO) &&
        notBe(me, roles.AUTORIZADO) &&
        notBe(me, roles.AUTORIZADO_CONSULTA)
    ) {
        roleOptions.push(roles.ADMINISTRADOR);
    }

    // APODERADO
    if (
        !me.is_minor &&
        me.intervener_type === 'F' &&
        notBe(me, roles.ADMINISTRADOR) &&
        notBe(me, roles.AUTORIZADO) &&
        notBe(me, roles.AUTORIZADO_CONSULTA)
    ) {
        roleOptions.push(roles.APODERADO);
    }

    // AUTORIZADO
    if (
        !me.is_minor &&
        me.intervener_type === 'F'
    ) {
        roleOptions.push(roles.AUTORIZADO);
    }

    // AUTORIZADO_CONSULTA
    if (
        !me.is_minor &&
        me.intervener_type === 'F'
    ) {
        roleOptions.push(roles.AUTORIZADO_CONSULTA);
    }

    // 'JUNTA_DIRECTIVA',
    if (
        !me.is_minor &&
        me.intervener_type === 'F'
    ) {
        roleOptions.push(roles.JUNTA_DIRECTIVA);
    }

    return roleOptions;
}

/**
 * Retorna roles
 * @param {*} others otros intervinientes de la cuenta
 * @param {*} me interviniente actual
 * @return {*} roles
 */
export function canNPRoles(others, me) {
    const roleOptions = [];
     // APODERADO
    if (
        !isMinor(me)
    ) {
        roleOptions.push(roles.APODERADO);
    }
    // APORTANTES
    if (
        !isMinor(me) &&
        (onlyOne(others, roles.TITULAR) || onlyOne(others, roles.NUDO_PROPIETARIO)) &&
        notExist(others, roles.APORTANTE_CONYUGE) &&
        notBe(me, roles.APORTANTE_FAMILIAR) &&
        notBe(me, roles.TITULAR)
    ) {
        roleOptions.push(roles.APORTANTE_CONYUGE);
    }
    if (
        !isMinor(me) &&
        (onlyOne(others, roles.TITULAR) || onlyOne(others, roles.NUDO_PROPIETARIO)) &&
        notBe(me, roles.APORTANTE_CONYUGE) &&
        notBe(me, roles.TITULAR)
    ) {
        roleOptions.push(roles.APORTANTE_FAMILIAR);
    }
    // 'AUTORIZADO',
    if (
        !isMinor(me) &&
        notBe(me, roles.AUTORIZADO_CONSULTA) &&
        notBe(me, roles.TITULAR) &&
        notBe(me, roles.NUDO_PROPIETARIO) &&
        notBe(me, roles.USUFRUCTUARIO)
    ) {
        roleOptions.push(roles.AUTORIZADO);
    }
    // 'AUTORIZADO_CONSULTA)',
    if (
        !isMinor(me) &&
        notBe(me, roles.AUTORIZADO) &&
        notBe(me, roles.TITULAR) &&
        notBe(me, roles.NUDO_PROPIETARIO) &&
        notBe(me, roles.USUFRUCTUARIO)
    ) {
        roleOptions.push(roles.AUTORIZADO_CONSULTA);
    }
    if (
        !isMinor(me) &&
        notBe(me, roles.NUDO_PROPIETARIO) &&
        notBe(me, roles.USUFRUCTUARIO) &&
        notBe(me, roles.TITULAR) &&
        notExist(others, roles.TITULAR)
    ) {
        roleOptions.push(roles.NUDO_PROPIETARIO);
    }
    // REPRESENTANTE_LEGAL
    if (
        !isMinor(me) &&
        others.length >= 1
    ) {
        roleOptions.push(roles.REPRESENTANTE_LEGAL);
    }
    // TITULAR
    if (
        notExist(others, roles.NUDO_PROPIETARIO) &&
        notExist(others, roles.USUFRUCTUARIO) &&
        notBe(me, roles.TITULAR) &&
        notBe(me, roles.NUDO_PROPIETARIO) &&
        notBe(me, roles.USUFRUCTUARIO) &&
        notBe(me, roles.APORTANTE_CONYUGE) &&
        notBe(me, roles.APORTANTE_FAMILIAR)
    ) {
        roleOptions.push(roles.TITULAR);
    }
    // TUTOR
    if (
        others.some(x => isMinor(x) ) &&
        !isMinor(me)
    ) {
        roleOptions.push(roles.TUTOR);
    } // USUFRUCTUARIO
    if (
        !isMinor(me) &&
        notBe(me, roles.USUFRUCTUARIO) &&
        notBe(me, roles.NUDO_PROPIETARIO) &&
        notBe(me, roles.TITULAR) &&
        notExist(others, roles.TITULAR) &&
        notExist(others, roles.USUFRUCTUARIO) &&
        onlyOne(others, roles.NUDO_PROPIETARIO)
    ) {
        roleOptions.push(roles.USUFRUCTUARIO);
    }
    return roleOptions;
}

/**
 * Devuelve los roles posibles
 * @param {*} accountTypes tipo de cuenta
 * @param {*} others los otros intervinientes
 * @param {*} me interviniente actual
 * @return {*} Listado de roles
 */
export function canRoles(accountTypes, others, me) {
    if (accountTypes === 'J') {
        return canLPRoles(others, me);
    }
    return canNPRoles(others, me);
}

/**
 * @override
 * @param {*} intervener interviniente
 * @param {*} now Ahora
 */
export function isMinor(intervener, now = moment()) {
    return intervener.birthdate ? now.diff(moment(intervener.birthdate), 'years') < 18
        && intervener.intervener_type === 'F' : false;
}

/**
 * @override
 * @param {*} document_expiration_date Fecha de cumpleaños
 * @param {*} now Ahora
 */
export function isDocumentExpired(document_expiration_date, now = moment()) {
    return now.isAfter(moment(document_expiration_date));
}

/**
 * Resuelve incompatibilidades entre autorizados
 * @param {*} selected listado de roles
 * @return {*} listado
 */
export  const autorizados = function (selected) {
    if (selected.includes('AUTORIZADO')) {
        return [ 'AUTORIZADO' ];
    } else if (selected.includes('AUTORIZADO_CONSULTA')) {
        return [ 'AUTORIZADO_CONSULTA' ];
    }
    return [ 'AUTORIZADO', 'AUTORIZADO_CONSULTA' ];
};

export  const PostalAddressDetail = () =>
    import(/* webpackChunkName: "IntervenerDetailRelated" */ '@/components/interveners/postal-address-detail');
export  const IntervenerSearcher = () => import(/* webpackChunkName: "interveners" */ './intervener-searcher');
export  const IntervenerForm = () => import(/* webpackChunkName: "interveners" */ './intervener-form');

/**
 * Comprueba si el interviniente posee los roles indicados.
 * @param {*} relationships relaciones
 * @param {*} keys roles
 * @return {Boolean} true si contiene rol
 */
export  const hasRole = (relationships, keys) => {
    return (relationships && relationships.some(role => keys.includes(role))) || false;
};

/**
 * Obtiene intervinientes nuevos y exitentes del rol especificado
 * @param {*} interveners -
 * @param {*} roles listado de roles
 * @return {*} Listado de intervinientes
 */
export  const getIntervenersWithRoles = function (interveners, roles) {
    return [...(interveners.filter(x => hasRole(x.account_intervener_role, roles)) || [])];
};

/**
 * Obtiene intervinientes nuevos y exitentes del tipo especificado
 * @param {*} interveners -
 * @param {*} person_type tipo de persona
 * @return {*} Listado de intervinientes
 */
export const getIntervenersWithPersonType = function (interveners, person_type) {
    return [...(interveners.filter(x => x.intervener_type === person_type) || [])];
};

export const fields = [
    {
        key: 'intervener_name',
        label: 'Nombre del interviniente',
        class: 'intervener_name'
    },
    {
        key: 'intervener_name',
        label: 'Nombre del interviniente',
        class: 'intervener_name'
    },
    {
        key: 'birthdate',
        label: 'Fecha nacimiento',
        class: 'birthdate'
    },
    {
        key: 'document_id',
        label: 'Documento',
        class: 'document_id'
    },
    {
        key: 'role',
        label: 'Roles',
        class: 'role'
    },
    {
        key: 'holding_percentage',
        label: '% Titularidad',
        class: 'holding_percentage'
    },
    {
        key: 'mailing',
        label: 'Medio de correspondencia',
        class: 'mailing'
    },
    {
        key: 'actions',
        label: '',
        class: 'actions'
    }
];

export const formatter = ( data,  selectedMailingType, selectedMailing ) => {
    return data.map((x, idx) => {
        const f = {};
        f['idx'] = idx;
        f['uuid'] = x.uuid;
        f['intervener_order'] = idx + 1;
        f['name'] = x.personalData ? x.personalData['name'] : x['name'];
        f['lastname_1'] = x.personalData ? x.personalData['lastname_1'] : x['lastname_1'];
        f['lastname_2'] = x.personalData ? x.personalData['lastname_2'] : x['lastname_2'];
        f['document_id'] = x.personalData ? x.personalData['document_id'] : x['document_id'];
        f['document_type'] = x.personalData ? x.personalData['document_type'] : x['document_type'];
        f['document_expiration_date'] = x.personalData
            ? x.personalData['document_expiration_date']
            : x['document_expiration_date'];
        f['is_document_expired'] = isDocumentExpired(f['document_expiration_date']);
        f['is_document_permanent'] = x.personalData
            ? x.personalData['is_document_permanent']
            : x['is_document_permanent'];
        f['email'] = x.contactData ? x.contactData['email'] : x['email'];
        f['birthdate'] = x.personalData ? x.personalData['birthdate'] : x['birthdate'];
        f['intervener_status'] = x.personalData ? x.personalData['intervener_status'] : x['intervener_status'];
        f['is_blocked'] = x.is_blocked || false;
        f['intervener_type'] = x.personalData ? x.personalData['intervener_type'] : x['intervener_type'];
        f['is_minor'] = isMinor(f);
        f['postal_addresses'] = x.postal_addresses || x.postalData;
        f['postal_address'] = x.postalData ? x.postalData[0] : x.postal_address;
        f['mailing_type'] = selectedMailingType[idx] ? selectedMailingType[idx] : x['mailing_type'];
        f['holding_percentage'] = parseFloat(x.personalData 
            ? x.personalData['holding_percentage'] 
            : x['holding_percentage']) || '';        
        if (f['mailing_type'] === 'EMAIL') {
            f['mailing'] = selectedMailing[idx] ?
                selectedMailing[idx] :
                {
                    key: 'EMAIL',
                    value: f['email']
                };
        }
        f['_data'] = x;
        f['account_intervener_role'] = x.account_intervener_role;
        return f;
    });
}

export const checkIfErrors = (formattedData, accountType) => {
    const minors = [...(formattedData.filter(x => x.is_minor) || [])];
    const tutors = getIntervenersWithRoles(formattedData, ['TUTOR']);
    const bareOwners = getIntervenersWithRoles(formattedData, ['NUDO_PROPIETARIO']);
    const beneficialOwners = getIntervenersWithRoles(formattedData, ['USUFRUCTUARIO']);
    const holders = getIntervenersWithRoles(formattedData, ['TITULAR']);
    const admin_apoder = getIntervenersWithRoles(formattedData, ['ADMINISTRADOR', 'APODERADO']);
    const juridical = getIntervenersWithPersonType(formattedData, 'J');
    const fisical = getIntervenersWithPersonType(formattedData, 'F');

    const totalShares = formattedData.reduce((sum, i) => {
        const val = parseFloat(i.holding_percentage);
        return sum + (isNaN(val) ? 0 : val);
    }, 0);

    if (Math.abs(totalShares - 100) > 0.01) {
        throw new Error(`La suma del porcentaje de titularidad debe ser 100%. Actualmente suma ${totalShares}%.`);
    }


    if (juridical.length && !fisical.length) {
        throw new Error('Al menos un interviniente debe ser persona física');
    }

    if (holders.length < 1 && bareOwners.length < 1) {
        throw new Error('Al menos un interviniente debe ser Titular o Nudo Propietario');
    }

    if (bareOwners.length && holders.length) {
        throw new Error(`No pueden existir titulares y nudo propietarios en la misma cuenta`);
    }

    if (bareOwners.length && !beneficialOwners.length) {
        throw new Error(`Debe exitir un usufructuario en la cuenta.`);
    }

    if (accountType === 'J' && !admin_apoder.length) {
        throw new Error('Debe existir al menos un Administrador o Apoderado en la cuenta.');
    }

    if (!bareOwners.length && beneficialOwners.length) {
        throw new Error(`Debe exitir un nudo propietario en la cuenta.`);
    }

    if (beneficialOwners.length > 1) {
        throw new Error(`Solo puede existir un usufructuario en la cuenta`);
    }

    if (minors && minors.length > 0 && (!tutors || tutors.length < 1)) {
        throw new Error('Debe existir un tutor en una cuenta con menores.');
    }
}